/*global $ */
/*eslint no-undef: "error"*/

export const minimiseLeftCanvasMenuOnSmallScreens = () => {
  const winWidth = document.body.clientWidth
  const navExpanded = $('body').hasClass('primary-nav-expanded')

  if (winWidth < 768 && navExpanded) {
    console.log('root/index.js: primary-nav-expanded - auto-clicking collapse button.')
    $('button#primaryNavToggle').click()
  }
}
